import { get } from "lodash";

export const getTemplateBuilderSection = (state, path) =>
  get(state, ["template", "templateBuilder", ...path.split(".")], {});

export const getTemplateSection = (state, path) =>
  get(state, ["template", ...path.split(".")], {});
